import { createFileRoute } from '@tanstack/react-router'
import { QuoteCommentsPage } from '@/features/quote-builder/comments/quote-comments-page'

export const Route = createFileRoute('/_authenticated/quotes/$quoteId/comments')({
  staticData: { title: 'Quote Comments' },
  component: CommentsRoute,
})

function CommentsRoute() {
  const { quoteId } = Route.useParams()
  return <QuoteCommentsPage quoteId={quoteId} />
}
